import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedServicesModule } from '../../../../shared/services/shared.services.module';
import { ProfileCollapsePanelsWidget } from './profile-collapse-panels-widget.component';

@NgModule({
  declarations: [ProfileCollapsePanelsWidget],
  imports: [CommonModule, SharedServicesModule],
  exports: [ProfileCollapsePanelsWidget],
  providers: [],
})
export class ProfileCollapsePanelsWidgetModule {}
